export const SAVE_REQUESTS_LIST = 'SAVE_REQUESTS_LIST'; 
export const SAVE_REQUEST_DETAILS = 'SAVE_REQUEST_DETAILS'; 